import type React from 'react';

type InputOptions = { allowNegative?: boolean; decimalPlaces?: number };

export const formatIntegerWithCommas = (value: string): string => {
	const valueWithoutCommas = value.replace(/,/g, '');
	return valueWithoutCommas.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const handleInputAmount = (
	event: React.ChangeEvent<HTMLInputElement>,
	options: InputOptions = {},
) => {
	const { allowNegative = false, decimalPlaces = 2 } = options;
	const input = event.target;
	const valueCurrent = input.value;
	const cursorPosition = input.selectionStart ?? 0;

	if (valueCurrent.startsWith('.')) {
		input.value = '';
		return;
	}

	let cleanValue = valueCurrent.replace(/[^\d.]/g, '');

	if (allowNegative) {
		const hasNegativeSign = cleanValue.startsWith('-');
		const hasNumbers = /\d/.test(cleanValue);

		if (hasNegativeSign && hasNumbers) {
			cleanValue = cleanValue.replace(/-/g, (match, offset) =>
				offset === 0 ? match : '',
			);
		}

		if (hasNegativeSign && !hasNumbers) {
			cleanValue = cleanValue.replace(/-/g, (match, offset) =>
				offset === 0 ? match : '',
			);
		}

		if (!hasNegativeSign && hasNumbers) {
			cleanValue = cleanValue.replace(/-/g, '');
		}
	} else {
		cleanValue = cleanValue.replace(/-/g, '');
	}

	if (decimalPlaces === 0) {
		cleanValue = cleanValue.replace(/\./g, '');
	}

	const [integerPart = '', decimalPart] = cleanValue.split('.');
	const formattedIntegerPart = formatIntegerWithCommas(integerPart);

	const limitedDecimalPart = decimalPart?.substring(0, decimalPlaces);

	const formattedValue =
		limitedDecimalPart !== undefined
			? `${formattedIntegerPart}.${limitedDecimalPart}`
			: formattedIntegerPart;

	const previousCommaCount = (valueCurrent.match(/,/g) || []).length;
	const newCommaCount = (formattedValue.match(/,/g) || []).length;
	const addedCommas = newCommaCount - previousCommaCount;

	input.value = formattedValue;

	const newCursorPosition = cursorPosition + addedCommas;
	input.setSelectionRange(newCursorPosition, newCursorPosition);
};

export default handleInputAmount;
